/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProfessionsQuery } from '../../models/get-professions-query';
import { GetProfessionsQueryResult } from '../../models/get-professions-query-result';

export interface GetAllProfessionsGet$Params {
  query?: GetProfessionsQuery;
}

export function getAllProfessionsGet(http: HttpClient, rootUrl: string, params?: GetAllProfessionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProfessionsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, getAllProfessionsGet.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProfessionsQueryResult>;
    })
  );
}

getAllProfessionsGet.PATH = '/GetAllProfessions';
